module.exports = __webpack_public_path__ + "static/media/towels-dark-gray.e0aa96da.svg";